import React, {FC} from 'react';
import styled, {useTheme} from 'styled-components';

import {Trans} from '../../../../../../../libs/shared/core/src/helpers/internationalization/components/trans';
import {isDefined} from '../../../../../../../libs/shared/core/src/helpers/typescript/typeHelpers';
import {inboxHasColor} from '../../../../../../../libs/shared/core/src/models/helpers/inboxHelpers';
import {useAppQuery} from '../../../../../../../libs/shared/core/src/services/query/useAppQuery';
import {ColorDot} from '../../../../../../../libs/shared/ui/src/components/utility/colorDot';
import {useAppSelector} from '../../../../../../helpers/appReduxHelpers';
import {inboxQueries} from '../../../../../../queries/inboxQueries';
import {getInboxes} from '../../../../../../store/data/inboxes/inboxesSelectors';
import {SearchInboxDropdownContainer} from '../../../../../common/dropdowns/search/searchInboxDropdownContainer';
import {MacroInputDropdownBoxCoordinator} from './common/macroInputDropdownBoxCoordinator';
import {MacroInputCommonProps} from './common/macroInputTypes';

/*
 * Props.
 */

export interface MacroInputInboxProps extends MacroInputCommonProps<number> {}

/*
 * Styles.
 */

const StyledWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

/*
 * Component.
 */

export const MacroInputInbox: FC<MacroInputInboxProps> = ({value, onChange, description, label}) => {
  const theme = useTheme();
  const inboxes = useAppSelector(getInboxes);
  const selectedInboxStore = isDefined(value) ? inboxes[value] : undefined;

  const selectedInboxQuery = useAppQuery({
    ...inboxQueries.id(value),
    enabled: isDefined(value) && !isDefined(selectedInboxStore),
  });

  const selectedInbox = selectedInboxStore ?? selectedInboxQuery.data;

  return (
    <MacroInputDropdownBoxCoordinator
      value={selectedInbox ?? undefined}
      renderValue={(inbox) => (
        <StyledWrapper>
          <ColorDot size={8} color={inboxHasColor(inbox) ? inbox.color : theme.greys.shade50} />
          {inbox.name}
        </StyledWrapper>
      )}
      placeholder={<Trans id="macro-input-inbox-placeholder">Select inbox</Trans>}
      label={label}
      description={description}
      renderDropdown={(popoverProps) => (
        <SearchInboxDropdownContainer
          // eslint-disable-next-line react/jsx-props-no-spreading
          {...popoverProps}
          selectedInboxIds={value ? [value] : []}
          width={260}
          maxHeight={400}
          onChange={(inbox) => onChange(inbox.id)}
        />
      )}
    />
  );
};
